<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisplayNormal',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('photo')" v-if="viewRaw && previewVisible">
      <img v-lazy="record?.downloadUrl" />
    </div>
    <div v-else :class="bem('icon')">
      <FileIcon :type="fileIcon" />
    </div>
    <div :class="bem('info')">
      <div :class="bem('name')" :title="fileName">{{ fileName }}</div>
      <div :class="bem('code')" :title="record?.fileCodeNumber">文件编号：{{ record?.fileCodeNumber ?? '-' }}</div>
      <div :class="bem('time')" :title="record?.fileShowTime">文件时间：{{ record?.fileShowTime ?? '-' }}</div>
    </div>
    <div :class="bem('actions')">
      <div :class="bem('btn')" title="预览" v-if="previewVisible" @click="handlePreview">
        <EyeOutlined />
      </div>
      <div :class="bem('btn')" title="下载" @click="download">
        <DownloadOutlined />
      </div>
      <div :class="bem('btn')" v-if="closeable" data-danger="1" title="移除" @click="$emit('del')">
        <CloseOutlined />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup name="FileDisplayNormal">
import { createNamespace } from '@bd/vue3-utils'
import { CloseOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons-vue'
import { FileIcon } from '-/Base/BdIcon'
import { fileDisplayNormalProps } from './props'
import { useFileDownload, useFileImagePreview, useFileMeta } from './useFile'

const [_, bem] = createNamespace('FileDisplayNormal')
const props = defineProps(fileDisplayNormalProps)

defineEmits(['del'])

const { fileIcon, fileName } = useFileMeta(props.record)
const { previewVisible, handlePreview } = useFileImagePreview(props.record)
const { download } = useFileDownload(props.record)
</script>

<style lang="less">
@ns: file-display-normal;

.@{ns} {
  display: flex;
  gap: @margin-sm;
  align-items: flex-start;
  padding: @padding-sm @padding-md;
  position: relative;
  border-radius: @border-radius-large;
  overflow: hidden;
  background: @bg-fade-0;
  cursor: pointer;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.2);
    transition: all 0.3s;
    content: '';
    pointer-events: none;
    opacity: 0;
  }

  &__icon {
    flex: 0 0 36px;
    position: relative;
    z-index: 0;

    .anticon {
      font-size: 36px;
    }
  }

  &__photo {
    flex: 0 0 90px;
    max-width: 90px;
    height: 60px;
    background: @white;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__info {
    flex: 1;
    width: 0;
    position: relative;
    z-index: 0;
  }

  &__name {
    .text-show-row(20px);
    font-weight: 700;
  }

  &__code,
  &__time {
    .text-show-row(20px);
    color: @text-color-secondary;
    font-size: 14px;
  }

  &__actions {
    display: flex;
    gap: @margin-xs;
    position: absolute;
    top: @margin-xs;
    right: @margin-xs;
    z-index: 3;
    opacity: 0;
    transition: all 0.3s;
    transform: translateY(-100px);
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 28px;
    color: @text-color-secondary;
    background: @white;
    transition: all 0.3s;
    cursor: pointer;
    box-shadow: @box-shadow-base;

    &[data-danger='1'] {
      color: @error-color;
    }

    &:hover {
      color: @primary-color;
    }

    .anticon {
      font-size: 14px;
    }
  }

  &:hover {
    &::after {
      opacity: 1;
    }

    .@{ns}__actions {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
